export default "__VITE_ASSET__vXJHIcj2__"